import React, { useRef, useState } from "react"
import styled from "styled-components"
import { Link } from "react-router-dom"
import axios from "axios"
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { selectLogInUsername } from "../../../../../common/authenticateDashboard/authSlice"
import { getDatabase, ref, get, set, update } from 'firebase/database';
import { nudges, nudgesCompany } from '../../../../../firebase';
import { nanoid } from 'nanoid'; // Import nanoid



import EmailEditor from "react-email-editor"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
`

const Bar = styled.div`
  flex: 1;
  background-color: #172b4d;
  color: #000;
  padding: 15px;
  display: flex;
  justify-content: center;
  max-height: 50px;
  align-items: center;

  h1 {
    flex: 1;
    font-size: 18px;
    text-align: left;
  }

  button {
    padding: 10px 15px;
    margin-left: 10px;
    font-size: 14px;
    font-weight: bold;
    background-color: #000;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #333;
    }

    &:active {
      background-color: #555;
    }
  }
`;



const DesignEdit = () => {
  const emailEditorRef = useRef(null)
  const [designName, setDesignName] = useState("") // State for storing design name
  const [preview, setPreview] = useState(false)
  const sessionUser = useSelector(selectLogInUsername)
  const { endpoint1, endpoint} = useParams();
  console.log("pint", endpoint)
  const user = sessionUser?.split('@')[0];
  const Viewer = {
    name: 'my_tool',
    label: 'My Tool',
    icon: 'fa-smile',
    supportedDisplayModes: ['web', 'email'],
    options: {},
    values: {},
    renderer: {
      // Viewer: Viewer, // our React Viewer
      exporters: {
        web: function (values) {
          return '<div>I am a custom tool.</div>';
        },
        email: function (values) {
          return '<div>I am a custom tool.</div>';
        },
      },
      head: {
        css: function (values) {},
        js: function (values) {},
      },
    },
  }
  const saveAndExportDesign = async () => {
    const unlayer = emailEditorRef.current?.editor;

    try {
      // Save design and export HTML concurrently using Promise.all
      const [design, { html }] = await Promise.all([
        new Promise((resolve, reject) => {
          unlayer?.saveDesign(design => {
            console.log("saveDesign", design);
            resolve(design);
          });
        }),
        new Promise((resolve, reject) => {
          unlayer?.exportHtml(data => {
            const { design, html } = data;
            console.log("exportHtml", html);
            resolve({ design, html });
          });
        })
      ]);

      // Post data to API
      // const apiUrl = `http://causalfunnel.app:6000/api/data/${user}/${designName} `;
      // const postData = { design, html };
      // const response = await axios.post(apiUrl, postData);

      // console.log("Data saved successfully:", response.data, "in", apiUrl);
      // alert("Data saved successfully.");

      const db = getDatabase(nudgesCompany);
      const userRef = ref(db, user);
      console.log("user--->", user);
      console.log("User ref", userRef);

      const userSnapshot = await get(userRef);
      if (!userSnapshot.exists()) {
        await set(userRef, {});
        console.log("Created");
      }
      console.log("user found")
      const uniqueId = nanoid();

      const newData = { [designName]: { design, html, name: designName, uniqueId } };


      // Function to recursively replace undefined values with null
      function replaceUndefinedWithNull(obj) {
        for (const key in obj) {
          if (typeof obj[key] === 'object' && obj[key] !== null) {
            replaceUndefinedWithNull(obj[key]);
          } else if (obj[key] === undefined) {
            obj[key] = null;
          }
        }
      }

      // Replace undefined values with null in newData
      replaceUndefinedWithNull(newData);

      console.log("newData-->", newData);

      await update(userRef, newData);

      console.log("Design", design);
      console.log("Data saved successfully");
      alert("Data saved successfully.");
    } catch (error) {
      console.error("Error:", error);
      alert("An error occurred while processing the data.");
    }
  };

  const togglePreview = () => {
    const unlayer = emailEditorRef.current?.editor

    if (preview) {
      unlayer?.hidePreview()
      setPreview(false)
    } else {
      unlayer?.showPreview("desktop")
      setPreview(true)
    }
  }

  const onDesignLoad = data => {
    console.log("onDesignLoad", data)
  }

  const onReady = unlayer => {
    console.log("onReady", unlayer)
  }

  const products = [
    {
      id: 1,
      image:
        "https://img.thriftbooks.com/api/images/i/m/B4380A756292C0D50D92213A920E5A9E6C1DD713.jpg",
      title: "The Great Believers",
      description:
        "A page turner... An absorbing and emotionally riveting story about what it's like to live during times of crisis. The New York Times Book Review A dazzling new novel of friendship and redemption in the face of tragedy and loss set in 1980s Chicago and contemporary Paris In 1985, Yale Tishman, the development director for an art gallery in Chicago, is about to pull off an amazing coup, bringing in an extraordinary collection of 1920s paintings as a gift to the gallery.",
    },
    {
      id: 2,
      image:
        "https://img.thriftbooks.com/api/images/i/m/F0836F0E91E904515A5A47078C555303CCC67351.jpg",
      title: "The Hundred-Year House",
      description:
        "From the acclaimed author of The Great Believers, an original, mordantly witty novel about the secrets of an old-money family and their turn-of-the-century estate, Laurelfield. Meet the Devohrs: Zee, a Marxist literary scholar who detests her parents' wealth but nevertheless finds herself living in their carriage house; Gracie, her mother, who claims she can tell your lot in life by looking at your teeth; and Bruce, her step-father, stockpiling supplies for the Y2K apocalypse and perpetually late for his tee time. ",
    },
  ];
  const onLoad = async (unlayer) => {
    console.log("onLoad", unlayer);


    try {
      const db = getDatabase(nudgesCompany); // Get a reference to the database
      const nudgesRef = ref(db, "/"); // Reference to the "predefinednudges" node
      const snapshot = await get(nudgesRef); // Fetch data from the database

      if (snapshot.exists()) {
        const data = snapshot.val(); // Retrieve the data from the snapshot
        console.log("Data fetched:", data);

        // Function to find the design by endpoint ID
        const findDesign = (obj) => {
          if(endpoint=="abandon-cart"){
            return obj.predefinednudges.abandon_cart.design
          }
          else if( endpoint == "browsed_product"){
            return obj.predefinednudges.browsed_product.design
          }
        };
        console.log("function ret", findDesign(data))

        const design = findDesign(data); // Call the function to find the design
        console.log("Found design:", design);

        if (unlayer) {
          if (design) {
            try {
              await new Promise((resolve, reject) => {
                unlayer.loadDesign(design, (error) => {
                  if (error) {
                    reject(new Error(`Failed to load design: ${error.message}`));
                  } else {
                    resolve();
                  }
                });
              });
              console.log('Design loaded successfully');
            } catch (error) {
              console.error('Error loading design:', error.message);
              alert('Failed to load the design.');
            }
          } else {
            console.log('Design not found');
          }
        } else {
          console.error('Unlayer editor is not initialized.');
          alert('Unlayer editor is not initialized.');
        }
      } else {
        console.log('No data available');
      }
    } catch (error) {
      console.error('Error fetching data:', error.message);
    }
  };

  return (
    <Container className="w-full h-auto">
      <Bar>

        {/* <input
          type="text"
          placeholder="Enter Design Name"
          value={designName}
          onChange={e => setDesignName(e.target.value)}
          style={{ marginRight: "10px" }}
        /> */}


        <div class="relative w-[80vh]">
          <input
            type="text"
            placeholder="Enter Design Name"
            value={designName}
            onChange={e => setDesignName(e.target.value)} class="block w-full p-2 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" Placeholder="Enter the Design name" required />
          <button onClick={saveAndExportDesign} class=" text-white absolute end-2.5 bottom-1.5 text-sm px-4 py-1 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg">Save Design</button>
        </div>


        <button onClick={togglePreview} class=" text-white text-sm px-4 py-1 bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg">
          {preview ? "Hide" : "Show"} Preview
        </button>
        {/* <button onClick={saveAndExportDesign} class="m-2 text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2" >Save Design</button> */}
      </Bar>

      <EmailEditor ref={emailEditorRef} onLoad={onLoad} onReady={onReady} displayMode="email" 
      // options={{
      //   designTags: {
      //     business_name: "My business",
      //     current_user_name: "Ron",
      //   },
      //   customCSS: [
      //     "https://examples.unlayer.com/examples/product-library-tool/productTool.css",
      //   ],
      //   customJS: [
      //     "/home/cypher/react-dashboard-with-chatbot/src/layout/CampaignFlows/UnlayerNudge/UnlayerNudge/components/custom.js",
      //   ],
      // }}
      
      // tools={{
      //   "custom#product_tool": {
      //     data: {
      //       products,
      //     },
      //     properties: {
      //       productLibrary: {
      //         editor: {
      //           data: {
      //             products,
      //           },
      //         },
      //       },
      //     },
      //   },
      // }}
      />
    </Container>
  )
}

export default DesignEdit